import spoCreateItemInitialValue from './createItemInitialValue'

const initialValue = () => ({})

export default initialValue
